<template>
  <SAIPageWrapper>
    <CarSearchTabs />
    <SAITitle text-align="left">Upload your car quote</SAITitle>
    <SAIFormError class="q-mt-md" v-if="errors.$error && errors.$dirty" />
    <p class="q-py-md">
      Upload the quote of the car you want and we will generate a novated quote
      for you.
    </p>
    <SAILink
      class="cursor-pointer"
      :disable="disable"
      label="Back"
      @click="$emit('click:no-quote-file')"
    />
    <div class="q-mt-lg" v-if="displayUsedCarFields">
      <SAIFormLabel class="text-left">Registration Number*</SAIFormLabel>
      <SAIInput
        :disable="disable"
        :error="errors.registrationNumber.$error"
        :value="registrationNumber"
        @input="$emit('update:registration-number', $event)"
      />
    </div>
    <div class="q-mt-lg">
      <SAIFormLabel class="text-left">Car Price*</SAIFormLabel>
      <SAIInput
        :disable="disable"
        :error="errors.carPrice.$error"
        prefix="$"
        :value="carPrice"
        type="number"
        @input="$emit('update:car-price', $event)"
      />
      <SAITip
        class="full-width q-mt-sm"
        v-if="carPriceTip"
        icon="eva-bulb-outline"
        :text="carPriceTip"
      />
    </div>
    <div class="q-mt-lg" v-if="displayUsedCarFields">
      <SAIFormLabel class="text-left">Current Odometer*</SAIFormLabel>
      <SAIInput
        :disable="disable"
        :error="errors.odometer.$error"
        :value="odometer"
        type="number"
        @input="$emit('update:odometer', $event)"
      />
    </div>
    <div class="q-mt-lg">
      <SAIFileDisplay
        :value="quoteFile"
        :disable="fileInteraction || disable"
        :loading="fileInteraction"
        :max-file-size="$Constants.UPLOAD_QUOTE_MAX_FILE_SIZE"
        :max-total-size="$Constants.UPLOAD_QUOTE_MAX_TOTAL_FILE_SIZE"
        :max-files="$Constants.UPLOAD_QUOTE_MAX_FILE"
        :accept="$Constants.UPLOAD_QUOTE_FILE_TYPES"
        placeholder="Upload Quote (if available)"
        :hint="$Constants.PROOF_HINT"
        @input="$emit('update:quote-file', $event)"
      />
    </div>
    <div class="q-mt-lg row justify-center" v-if="displayUsedCarFields">
      <SAIBtn
        :disable="disable"
        :loading="happyWithQuoteLoading"
        :no-caps="true"
        padding="12px xl"
        label="I'm done, get me a quote"
        @click="$emit('click:happy-with-quote')"
      />
    </div>
    <div class="q-mt-lg row q-col-gutter-x-sm" v-else>
      <div class="col-6">
        <SAIBtn
          :disable="disable"
          :loading="happyWithQuoteLoading"
          class="full-height full-width rounded-borders-lg"
          outline
          :no-caps="true"
          label="I am happy, proceed with this quote"
          @click="$emit('click:happy-with-quote')"
        />
      </div>
      <div class="col-6">
        <SAIBtn
          :disable="disable"
          :loading="findBetterQuoteLoading"
          class="full-height full-width rounded-borders-lg"
          outline
          :no-caps="true"
          label="Find me a better quote"
          @click="$emit('click:request-better-quote')"
        />
      </div>
    </div>
  </SAIPageWrapper>
</template>
<script>
import {
  SAIBtn,
  SAIPageWrapper,
  SAITitle,
  SAIFileDisplay,
  SAIInput,
  SAIFormLabel,
  SAILink,
  SAITip,
  SAIFormError
} from 'ecx.saigon.ui.common';

export default {
  name: 'QuoteUpload',
  props: {
    carPriceTip: String,
    disable: Boolean,
    displayUsedCarFields: Boolean,
    odometer: undefined,
    carPrice: undefined,
    registrationNumber: undefined,
    quoteFile: undefined,
    happyWithQuoteLoading: Boolean,
    findBetterQuoteLoading: Boolean,
    noQuoteLoading: Boolean,
    errors: {
      type: Object,
      default: () => ({
        registrationNumber: {},
        carPrice: {},
        odometer: {}
      })
    },
    fileInteraction: Boolean
  },
  components: {
    SAIBtn,
    SAIPageWrapper,
    SAITitle,
    SAIFileDisplay,
    SAIInput,
    SAIFormLabel,
    SAILink,
    SAITip,
    SAIFormError,
    CarSearchTabs: () => import('../../../widgets/car-search-tabs')
  }
};
</script>
